<template>
  <div class="">
    <IncomingComponent v-if="data" :data="data" />
  </div>
</template>

<script>
import { IncomingLineData } from './data.js'
import IncomingComponent from './components/incoming.vue'
export default {
  components: { IncomingComponent },
  data() {
    return {
      componentName: '',
      data: null
    }
  },
  created() {
    let id = this.$route.query.id
    if (id) {
      this.data = IncomingLineData[id] || null
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped></style>
